"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePostgresQueries = exports.validatePostgresQuery = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const formula_engine_1 = require("@finley-technologies/formula-engine");
const postgresConfig_1 = require("./postgresConfig");
const utils = __importStar(require("./utils"));
const getFormulaConfigErrors = ({ config, variableNames, postgresQueryName, parameterConfigKey, }) => {
    const errors = [];
    const { engineVersion, formula } = config;
    if (engineVersion !== finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1) {
        errors.push(`Error in [postgresQuery:${postgresQueryName}] [parameterConfig:${parameterConfigKey}].  Unsupported formula engine ${engineVersion}.`);
        return errors;
    }
    const formulaErrors = (0, formula_engine_1.getFormulaErrors)(formula, variableNames);
    formulaErrors.errorMessages.forEach((err) => {
        errors.push(`Error in [postgresQuery:${postgresQueryName}] [parameterConfig:${parameterConfigKey}]. Error: ${err}`);
    });
    return errors;
};
const validatePostgresQuery = ({ postgresQuery, }) => {
    try {
        const errors = [];
        const { name, variables, parameterConfig } = postgresQuery;
        const parsedVariables = variables.map(({ name: varName, value, parseNumber }) => ({
            name: varName,
            value: common_1.stringConversion.parseStringValueToSqlPrimitive({
                value,
                // We're actually parsing a string here to potentially another type.
                // "parseNumber" here represents the trigger whether to attempt parsing
                // the input value (which is a string)
                parseString: parseNumber,
            }),
        }));
        const { keyMap, errors: keyVariableErrors } = (0, formula_engine_1.keyByVariableName)(parsedVariables);
        if (keyVariableErrors.length > 0) {
            keyVariableErrors.forEach((err) => errors.push(`Error creating variables [postgresQuery:${name}] [message:${err}]`));
            return errors;
        }
        const variableNames = new Set(Object.keys(keyMap));
        Object.entries(parameterConfig).forEach(([key, config]) => {
            const { type } = config;
            switch (type) {
                case 'formula': {
                    const formulaErrors = getFormulaConfigErrors({
                        config,
                        variableNames,
                        parameterConfigKey: key,
                        postgresQueryName: name,
                    });
                    formulaErrors.forEach((err) => {
                        errors.push(err);
                    });
                    break;
                }
                case 'tAccountDetailsArray':
                case 'orgProvidedInputKey':
                case 'capitalProviderSlugArray': {
                    // these configs are validated during save / commit since it requires
                    // additional async calls
                    break;
                }
                case 'reportingPeriod': {
                    // there is nothing to logically validate at this point, config
                    // is typesafe, and checked by typeguard
                    // as config complexity grows, we may need logical checks here
                    break;
                }
                default:
                    errors.push(`Error in [postgresQuery:${name}] [parameterConfig:${key}].  Unsupported configuration type ${type}.`);
            }
        });
        if (errors.length)
            return errors;
        // it's not guaranteed that we will always be able to eagerly validate all pg query configs
        const configErrors = (0, postgresConfig_1.validatePostgresQueryConfig)({
            postgresQuery,
            variables,
        });
        return configErrors;
    }
    catch (err) {
        return utils.handleError({
            err,
            prefix: `Error during validatePostgresQuery. PostgresQuery: ${postgresQuery.name}.`,
        });
    }
};
exports.validatePostgresQuery = validatePostgresQuery;
const validatePostgresQueries = (postgresQueries) => {
    const errors = [];
    const queryResultVariablesSet = new Set();
    postgresQueries.forEach((postgresQuery) => {
        const postgresErrors = (0, exports.validatePostgresQuery)({ postgresQuery });
        postgresErrors.forEach((err) => {
            errors.push(err);
        });
        if (queryResultVariablesSet.has(postgresQuery.name)) {
            errors.push(`Error during validatePostgresQueries. Duplicate postgres query name: ${postgresQuery.name}`);
        }
        else {
            queryResultVariablesSet.add(postgresQuery.name);
        }
    });
    return { errors, queryResultVariables: Array.from(queryResultVariablesSet) };
};
exports.validatePostgresQueries = validatePostgresQueries;
//# sourceMappingURL=postgres.js.map